import MyLinks from "./components/MyLinks";
import MyRouter from "./components/MyRouter";

function App() {
  return (
    <div>
      <MyLinks></MyLinks>
      <MyRouter></MyRouter>
    </div>
  );
}

export default App;
